jQuery(document).ready(function ($) {
	//Notice Function
	function show_notice(notice_type, notice) {
		$('.jscott-notice').html(notice).attr('class', 'jscott-notice').addClass('jscott-nt-' + notice_type);
		$('.jscott-notice-box').fadeIn('fast');
		clearTimeout(fadenotice);
		var fadenotice = setTimeout(function () {
			$('.jscott-notice-box').fadeOut('fast');
		}, 6000);
	}

	//Add to cart function
	function add_to_cart(atc_btn, form_data) {
		// Trigger event.
		$(document.body).trigger('adding_to_cart', [atc_btn, form_data]);

		$.ajax({
			url: jscottAjax.wc_ajax_url.toString().replace('%%endpoint%%', 'jscott_add_to_cart'),
			type: 'POST',
			data: $.param(form_data),
			success: function (response) {
				$('.jscott-cart-adding', atc_btn).remove();

				if (response.fragments) {
					// Trigger event so themes can refresh other areas.
					$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, atc_btn]);
					atc_btn.append('<i class="icon-checkmark jscott-cart-added"></i>');
				} else if (response.error) {
					show_notice('error', response.error);
					//open_popup();
				} else {
					$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, atc_btn]);
					$(document.body).trigger('wc_fragment_refresh');
				}
			}
		})
	}

	//Add to cart on single page
	$(document).on('submit', 'form.cart', function (e) {
		e.preventDefault();

		var form = $(this);
		var atc_btn = form.find('button[type="submit"]');

		$('.jscott-cart-added', atc_btn).remove();
		atc_btn.append('<i class="icon-spinner jscott-cart-adding"></i>');
		atc_btn.addClass('loading');

		var form_data = form.serializeArray();

		// if button as name add-to-cart get it and add to form
		if (atc_btn.attr('name') && atc_btn.attr('name') == 'add-to-cart' && atc_btn.attr('value')) {
			form_data.push({
				name: 'add-to-cart',
				value: atc_btn.attr('value')
			});
		}

		form_data.push({
			name: 'action',
			value: 'jscott_add_to_cart'
		});

		add_to_cart(atc_btn, form_data); //Ajax add to cart
	})

	var jscott_added_to_cart = function (e, fragments, cart_hash, $button) {
		console.log(fragments);
		$button = typeof $button === 'undefined' ? false : $button;
		if ($button) {
			// View cart text.
			if (fragments && !wc_add_to_cart_params.is_cart && $button.parent().find('.jscott_added_to_cart').length === 0) {
				$button.after('<a href="' + wc_add_to_cart_params.cart_url + '" class="btn btn-outline-gray3 jscott_added_to_cart position-relative" style="display:none" title="' +
					wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + fragments['.jscott-cart-btn-count'] + '</a>');
					$button.fadeOut('fast', function() {
						$button.parent().find('.jscott_added_to_cart').fadeIn('fast');
					  });
			} else if (fragments && !wc_add_to_cart_params.is_cart && $button.parent().find('.jscott_added_to_cart').length) {
				$button.fadeOut('fast', function() {
					$button.parent().find('.jscott_added_to_cart').fadeIn('fast');
				  });
			}

			setTimeout(function () {
				$button.parent().find('.jscott_added_to_cart').fadeOut('fast', function() {
					// This code runs after the fade-out animation is complete
					// Apply a fade-in effect to the button
					$button.fadeIn('fast');
				  });
			}, 6000);

			$(document.body).trigger('jscott_cart_button_updated', [$button]);
		}
	};

	$(document.body).on('added_to_cart', jscott_added_to_cart);

	function handleCartInput() {
		if ($('.jscott_added_to_cart').length) {
			var $button = $(this).closest('form.cart').find('button[type="submit"]');
			$('.jscott_added_to_cart').hide();
			$button.show();
		}
	}

	// Bind the function to the 'click' event for elements with class '.qib-select'
	$('.qib-button').on('click', handleCartInput);

	// Bind the same function to the 'input' event for 'form.cart input.qty' elements
	$('form.cart input.qty').on('input', handleCartInput);

	//Update cart
	function update_cart(cart_key, new_qty) {
		cart_loading();
		$.ajax({
			url: jscottAjax.wc_ajax_url.toString().replace('%%endpoint%%', 'jscott_update_cart'),
			type: 'POST',
			data: {
				cart_key: cart_key,
				new_qty: new_qty
			},
			success: function (response) {
				if (response.fragments) {
					refresh_fragments(response);
				} else {
					show_notice('error', response.error);
				}

				cart_loaded();
			}
		})
	}

	//Save Quantity on focus
	$(document).on('focusin', '#jscott-mini-cart input.qty', function () {
		var focus_qty = $(this).val();
	})

	//Qty input on change
	$(document).on('change', '#jscott-mini-cart input.qty', function (e) {
		var _this = $(this);
		var new_qty = parseFloat($(this).val());
		var step = parseFloat($(this).attr('step'));
		var min_value = parseFloat($(this).attr('min'));
		var max_value = parseFloat($(this).attr('max'));
		var invalid = false;

		if (new_qty === 0) {
			_this.closest('li').find('.remove-from-cart').trigger('click');
			return;
		}

		//Check If valid number
		else if (isNaN(new_qty) || new_qty < 0) {
			invalid = true;
		}

		//Check maximum quantity
		else if (new_qty > max_value && max_value > 0) {
			alert('Maximum Quantity: ' + max_value);
			invalid = true;
		}

		//Check Minimum Quantity
		else if (new_qty < min_value) {
			invalid = true;
		}

		//Check Step
		else if ((new_qty % step) !== 0) {
			alert('Quantity can only be purchased in multiple of ' + step);
			invalid = true;
		}

		//Update if everything is fine.
		else {
			var cart_key = $(this).closest('li').data('cart-item-key');
			update_cart(cart_key, new_qty);
		}

		if (invalid === true) {
			$(this).val(focus_qty);
		}
	})

	$('form.checkout').on('change', 'select[name="billing_state"]', function () {
		$(document.body).trigger('update_checkout');
	});

	$("#jscott_email").on("input", function () {
		// Update the hidden email field with the value from the visible field
		$("#billing_email").val($(this).val());
	});

	$(document).on('click', '#empty-cart-link', function (e) {
		e.preventDefault();
		if (confirm('Are you sure you want to remove all items from your cart?')) {
			// Use AJAX to update the cart without refreshing the page
			$.ajax({
				type: 'POST',
				url: wc_cart_fragments_params.ajax_url,
				data: {
					action: 'jscott_empty_cart'
				},
				success: function (response) {
					// Redirect to the cart page
					window.location.reload();
			}
			});
		}
	});
})
/*
jQuery(document).ready(function($) {
	// Main function to handle WOOF checkbox behaviors
	function setupWoofCheckboxLogic() {
	  // Store a processing flag to prevent event loops
	  var isProcessing = false;
	  
	  // PARENT CHECKBOX HANDLING
	  $(document).on('ifChecked', '.woof_childs_list_li > div > input.woof_checkbox_term', function(event) {
		if (isProcessing) return;
		isProcessing = true;
		
		var parentCheckbox = $(this);
		var childCheckboxes = parentCheckbox.closest('li').find('ul.woof_childs_list input.woof_checkbox_term:checked');
		
		// Uncheck all checked children
		if (childCheckboxes.length > 0) {
			childCheckboxes.each(function() {
			$(this).iCheck('uncheck');

			isProcessing = false;
		  });
		} else {
		  isProcessing = false;
		}
	  });
	  
	  // CHILD CHECKBOX HANDLING
	  $(document).on('ifChecked', 'ul.woof_childs_list input.woof_checkbox_term', function(event) {
		if (isProcessing) return;
		isProcessing = true;
		
		var childCheckbox = $(this);
		var parentLi = childCheckbox.closest('ul.woof_childs_list').closest('li.woof_childs_list_li');
		var parentCheckbox = parentLi.find('> div > input.woof_checkbox_term');
		
		// If parent is checked, uncheck it
		if (parentCheckbox.prop('checked')) {
			// Use iCheck's method to uncheck
			parentCheckbox.iCheck('uncheck');	
			isProcessing = false;
		} else {
		  isProcessing = false;
		}
	  });
	}
	
	// Function to fix any inconsistent states (run after AJAX updates)
	function fixCheckboxStates() {
	  // Process all checked child checkboxes
	  $('.woof_childs_list input.woof_checkbox_term:checked').each(function() {
		var childCheckbox = $(this);
		var parentLi = childCheckbox.closest('ul.woof_childs_list').closest('li.woof_childs_list_li');
		var parentCheckbox = parentLi.find('> div > input.woof_checkbox_term');
		
		// If parent is also checked, uncheck it
		if (parentCheckbox.prop('checked')) {
		  parentCheckbox.iCheck('uncheck');
		}
	  });
	  
	  // Process all checked parent checkboxes
	  $('.woof_childs_list_li > div > input.woof_checkbox_term:checked').each(function() {
		var parentCheckbox = $(this);
		var childCheckboxes = parentCheckbox.closest('li').find('ul.woof_childs_list input.woof_checkbox_term:checked');
		
		// If any children are checked, uncheck them
		childCheckboxes.each(function() {
		  $(this).iCheck('uncheck');
		});
	  });
	}
	
	// Initialize logic on page load
	setupWoofCheckboxLogic();
	fixCheckboxStates();
	
	// Re-apply after WOOF AJAX updates
	$(document).on('woof_ajax_done', function() {
	  setTimeout(function() {
		fixCheckboxStates();
		setupWoofCheckboxLogic();
	  }, 200);
	});
	
	// Fallback for any AJAX updates
	$(document).ajaxComplete(function(event, xhr, settings) {
	  if (settings.url && settings.url.indexOf('woof') > -1) {
		setTimeout(function() {
		  fixCheckboxStates();
		  setupWoofCheckboxLogic();
		}, 200);
	  }
	});
  });*/